import PropTypes from 'prop-types';

export default PropTypes.shape({
  reporter: PropTypes.shape({
    role: PropTypes.string.isRequired,
    fullName: PropTypes.string.isRequired
  }),
  id: PropTypes.number.isRequired,
  createdAt: PropTypes.string.isRequired,
  activelyTakingFlag: PropTypes.bool.isRequired
});
